// extracted by mini-css-extract-plugin
export default {"button":"editUserForm__button-zdmTu","avatarColumn":"editUserForm__avatarColumn-ekE2I","removeColumn":"editUserForm__removeColumn-EGGNC","noOrgMsg":"editUserForm__noOrgMsg-VkNk9"};